// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__18kBn","containerDocuments":"styles_containerDocuments__1174_"};